const locale = {
  placeholder: 'Odaberi vrijeme',
};

export default locale;
